/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidence200ResponseErrors } from './get-payment-request-evidence200-response-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidence200ResponseFile } from './get-payment-request-evidence200-response-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidence200ResponseInvoiceIssuer } from './get-payment-request-evidence200-response-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidence200ResponseUpdatedBy } from './get-payment-request-evidence200-response-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidence200ResponseUploadedBy } from './get-payment-request-evidence200-response-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidence200ResponseWarnings } from './get-payment-request-evidence200-response-warnings';

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200Response
 */
export interface GetPaymentRequestEvidence200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'paymentType': GetPaymentRequestEvidence200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'electronicMethod': GetPaymentRequestEvidence200ResponseElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'documentSize': GetPaymentRequestEvidence200ResponseDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'legalValidity': GetPaymentRequestEvidence200ResponseLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseFile}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'file': GetPaymentRequestEvidence200ResponseFile;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseInvoiceIssuer}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'invoiceIssuer': GetPaymentRequestEvidence200ResponseInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseErrors}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'errors': GetPaymentRequestEvidence200ResponseErrors;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseWarnings}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'warnings': GetPaymentRequestEvidence200ResponseWarnings;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseUpdatedBy}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'updatedBy': GetPaymentRequestEvidence200ResponseUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseUploadedBy}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'uploadedBy': GetPaymentRequestEvidence200ResponseUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'needsMigration'?: boolean;
}

export const GetPaymentRequestEvidence200ResponsePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestEvidence200ResponsePaymentTypeEnum = typeof GetPaymentRequestEvidence200ResponsePaymentTypeEnum[keyof typeof GetPaymentRequestEvidence200ResponsePaymentTypeEnum];
export const GetPaymentRequestEvidence200ResponseElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseElectronicMethodEnum = typeof GetPaymentRequestEvidence200ResponseElectronicMethodEnum[keyof typeof GetPaymentRequestEvidence200ResponseElectronicMethodEnum];
export const GetPaymentRequestEvidence200ResponseDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseDocumentSizeEnum = typeof GetPaymentRequestEvidence200ResponseDocumentSizeEnum[keyof typeof GetPaymentRequestEvidence200ResponseDocumentSizeEnum];
export const GetPaymentRequestEvidence200ResponseLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestEvidence200ResponseLegalValidityEnum = typeof GetPaymentRequestEvidence200ResponseLegalValidityEnum[keyof typeof GetPaymentRequestEvidence200ResponseLegalValidityEnum];


